<template>
    <div>
        <div class="d-md-none pb-3 pb-md-0">
            <router-link class="btn btn-primary btn-select-accessories" :to="{name:'catalog'}">
                {{t('button.accessories')}}
            </router-link>
        </div>

        <div class="d-none d-md-block">
            <loading v-if="loading"></loading>
            <div v-else>
                <div class="home-catalog-message" v-if="catalogMessage" v-html="catalogMessage"></div>

                <div v-if="error">{{t('error')}}</div>
                <div v-else>
                    <products-grouping v-for="grouping in products" :grouping="grouping"/>
                </div>
            </div>
        </div>
    </div>
</template>

<script>

    import mixin_constraints from "@/mixins/constraints";
    import {retryRequest} from "@/helpers/request";

    import Loading from "@/components/Loading";
    import ProductsGrouping from "@/components/products/ProductsGrouping";
    import emitter, {EVENTS} from "@/api/events";

    export default {
        name: "ViewsHomeTypeProducts",
        mixins: [mixin_constraints],
        components: {
            ProductsGrouping,
            Loading
        },
        props: {
            grouping: {
                type: String,
                required: true
            },
            groupings: {
                type: Array,
                required: true
            },
            config: {
                type: Object,
                required: true
            },
            catalogMessage: String
        },
        data() {

            return {
                t_path: "views.home",
                loading: false,
                error: false,
                products: [],
            }
        },
        methods: {
            processProductsGrouping(productsGrouping, options = {}) {

                const items = this.constraints_filterAvailableProducts(productsGrouping.products);
                const max = this.config[productsGrouping._id]
                    ? this.config[productsGrouping._id].max_items
                    : this.config.default.max_items;
                const total = "undefined" !== typeof productsGrouping.total
                    ? productsGrouping.total
                    : items.length;

                if ("undefined" !== typeof options.updateIndex) {

                    this.products[options.updateIndex].items = items.slice(0, max);
                    this.products[options.updateIndex].showMore = total > items.slice(0, max).length;
                } else {

                    this.$activity.log("catalog_grouping_products", {
                        grouping_id: productsGrouping._id,
                        products: items.slice(0, max),
                        constraints: this.$store.getters["user/constraints/type"]
                    });

                    this.products.push({
                        ...productsGrouping,
                        id: productsGrouping._id,
                        type: this.grouping,
                        items: items.slice(0, max),
                        showMore: total > items.slice(0, max).length
                    });
                }
            },
            fetch() {

                this.loading = true;

                const promises = this.groupings.map(item => retryRequest(() => this.$platform.get(`/api/v2/grouping/${this.grouping}/${item.id}`)));

                return Promise
                    .all(promises)
                    .then(responses => responses.forEach(response => this.processProductsGrouping(response.data.results)))
                    .catch(() => this.error = true)
                    .finally(() => this.loading = false);
            },
            refresh() {

                this.products.forEach((productsGroup, productsGroupIndex) => this.$platform
                    .get(`/api/v2/grouping/${this.grouping}/${productsGroup.id}`)
                    .then(response => this.processProductsGrouping(response.data.results, {updateIndex: productsGroupIndex}))
                );
            }
        },
        mounted() {

            this.fetch();

            emitter.on(EVENTS.USER_CONSTRAINTS_FETCH, this.refresh);
        },
        beforeUnmount() {

            emitter.off(EVENTS.USER_CONSTRAINTS_FETCH, this.refresh);
        }
    }
</script>